/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { ContentZoneContext } from "cms/components/context";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { ImageLinkItem } from "cms/components/components/image-link/display/image-link-item";

const HighlightComponentDisplay = () => {
    
    const ctx = useContext(ContentZoneContext);
    const { token } = useAuth();
    const { component } = ctx || {};
    const {
        description,
        image: _image,
        image_links: imageLinks,
        section_name,
        subtitle,
        title
    } = component || {};
    
    const [image, setImage] = useState();

    const hasImageLinks = imageLinks && imageLinks.length > 0;
    
    useEffect(() => {
        async function fetchData () {
            if (_image) {
                const data = await SimpliCityAdminSDK.image.findOne(token, _image);
                setImage(data);
            }
        }
        fetchData();
    }, [token, _image]);
    
    return (
        <div className='highlight-component-display'>

            {image &&
                <div className='highlight-image'>
                    <img
                        src={image.url}
                        alt={image?.alt || "SimpliCity image"}
                    />
                </div>
            }

            {section_name && <h4>{section_name}</h4>}
            {title && <h2>{title}</h2>}
            {subtitle && <h2>{subtitle}</h2>}

            <RichTextPreview richtext={description} />

            {hasImageLinks &&
                <div className='image-link-items-container'>
                    {imageLinks.map((item, index) => (
                        <ImageLinkItem item={item} key={`highlight-image-link-${index}`} />
                    ))}
                </div>
            }

        </div>
    );
};

HighlightComponentDisplay.displayName = "HighlightComponentDisplay";
export { HighlightComponentDisplay };
